import { SVGProps } from 'react';

export const IconPass = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.75 6.25C12.75 6.66421 12.4142 7 12 7C11.5858 7 11.25 6.66421 11.25 6.25C11.25 5.83579 11.5858 5.5 12 5.5C12.4142 5.5 12.75 5.83579 12.75 6.25ZM14.122 7C14.2049 6.76542 14.25 6.51298 14.25 6.25C14.25 5.00736 13.2426 4 12 4C10.7574 4 9.75 5.00736 9.75 6.25C9.75 6.51298 9.79512 6.76542 9.87803 7H6C5.17157 7 4.5 7.67157 4.5 8.5V17.5C4.5 18.3284 5.17157 19 6 19H18C18.8284 19 19.5 18.3284 19.5 17.5V8.5C19.5 7.67157 18.8284 7 18 7H14.122ZM10.6667 11.3334C10.6667 12.2539 9.92048 13.0001 9 13.0001C8.07953 13.0001 7.33333 12.2539 7.33333 11.3334C7.33333 10.4129 8.07953 9.66675 9 9.66675C9.92048 9.66675 10.6667 10.4129 10.6667 11.3334ZM18 10.75H13.5V12.25H18V10.75ZM18 13.75H13.5V15.25H18V13.75ZM9 13.6667C7.99865 13.6667 6 14.2623 6 15.4445V16.3334H12V15.4445C12 14.2623 10.0013 13.6667 9 13.6667Z'
        fill='currentColor'
      />
    </svg>
  );
};
